import { Loan } from '../types/loan'

const generateConditions = (count: number, prefix: string) => {
  return Array.from({ length: count }).map((_, i) => ({
    id: `${prefix}-${i}`,
    text: `${prefix} condition item #${i + 1} - needs review`,
    completed: false,
  }))
}

export const mockLoans: Record<string, Loan[]> = {
  CTC: [
    {
      id: 'ctc1',
      loanNumber: '57025114370',
      loanNumberColor: 'default',
      clientName: 'Martinez, Sofia',
      loanOfficerAssistant: 'Sarah Johnson',
      manager: 'Michael Chen',
      branch: 'West Coast',
      division: 'Retail',
      lender: 'UWM',
      amount: 425000,
      program: 'C/O',
      state: 'CA',
      lockStatus: 'Float',
      notes: 'Initial review pending',
      submittedDate: '11/28/2025',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: '',
      appraisalStatus: 'Not ordered',
      daysInStage: 1,
      statusColor: 'green',
      outstandingConditions: generateConditions(2, 'Outstanding'),
      loanOfficerConditions: generateConditions(1, 'LO'),
      contacts: 'Sofia Martinez',
      titleInfo: 'Pending',
      loanOfficer: 'Jake Morrison',
      closingDate: '2/15/2026',
      loanPurpose: 'Purchase',
      loanType: 'Conventional',
      cdSentDate: '2/1/2026',
      buyersAgent: 'Lisa Smith',
      processor: 'Amanda Lee',
      lastContactDate: '2/10/2026',
      overdueActionItems: 0,
      loanStatus: 'Active',
    },
    {
      id: 'ctc2',
      loanNumber: '57025114371',
      loanNumberColor: 'yellow',
      clientName: 'Thompson, David',
      loanOfficerAssistant: 'Emily Davis',
      manager: 'Robert Williams',
      branch: 'Midwest',
      division: 'Wholesale',
      lender: 'Village',
      amount: 380000,
      program: 'R/T',
      state: 'TX',
      lockStatus: '',
      notes: 'Awaiting initial docs',
      submittedDate: '11/27/2025',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: '',
      appraisalStatus: 'Not ordered',
      daysInStage: 2,
      statusColor: 'yellow',
      outstandingConditions: generateConditions(3, 'Outstanding'),
      loanOfficerConditions: generateConditions(2, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '3/1/2026',
      loanPurpose: 'Refinance',
      loanType: 'FHA',
      processor: 'Jessica Martinez',
      lastContactDate: '2/8/2026',
      overdueActionItems: 1,
      loanStatus: 'Active',
    },
  ],
  'CD OUT': [
    {
      id: '1',
      loanNumber: '57025114363',
      loanNumberColor: 'default',
      clientName: 'Boots, Robert',
      loanOfficerAssistant: 'Jessica Martinez',
      manager: 'Michael Chen',
      branch: 'East Coast',
      division: 'Retail',
      lender: 'Village',
      amount: 243050,
      program: 'C/O',
      state: 'IN',
      lockStatus: 'Locked',
      notes: 'Supp',
      submittedDate: '11/25/2025',
      payoffReqStatus: 'IN',
      payoffExpDate: '26-Jan',
      hoiReqStatus: 'IN',
      appraisalStatus: 'Appraisal IN 10/14',
      daysInStage: 2,
      statusColor: 'green',
      outstandingConditions: generateConditions(3, 'Outstanding'),
      loanOfficerConditions: generateConditions(2, 'LO'),
      contacts: 'Robert Boots (Primary)',
      rateLock: 'Locked until 02/15',
      payoffDue: '1-Feb',
      titleInfo: 'R25TX176846',
      appraisalNotes: 'Value came in at $250k',
      loanOfficer: 'Jake Morrison',
      closingDate: '2/20/2026',
      loanPurpose: 'Cash-Out',
      loanType: 'Conventional',
      cdSentDate: '2/5/2026',
      processor: 'Sarah Johnson',
      lastContactDate: '2/12/2026',
      overdueActionItems: 0,
      loanStatus: 'Active',
    },
    {
      id: '2',
      loanNumber: '57025114364',
      loanNumberColor: 'default',
      clientName: 'Smith, John',
      loanOfficerAssistant: 'Amanda Lee',
      manager: 'Robert Williams',
      branch: 'Midwest',
      division: 'Correspondent',
      lender: 'UWM',
      amount: 315000,
      program: 'C/O',
      state: 'OH',
      lockStatus: 'Float',
      notes: 'Waiting on docs',
      submittedDate: '11/26/2025',
      payoffReqStatus: 'Req',
      payoffExpDate: '28-Jan',
      hoiReqStatus: 'Req',
      appraisalStatus: 'Ordered',
      daysInStage: 1,
      statusColor: 'green',
      outstandingConditions: generateConditions(5, 'Outstanding'),
      loanOfficerConditions: generateConditions(1, 'LO'),
      loanOfficer: 'Sarah Jenkins',
      closingDate: '3/15/2026',
      loanPurpose: 'Purchase',
      loanType: 'VA',
      buyersAgent: 'Tom Wilson',
      processor: 'Emily Davis',
      lastContactDate: '2/1/2026',
      overdueActionItems: 2,
      loanStatus: 'Active',
    },
  ],
  'ALL IN': [
    {
      id: '3',
      loanNumber: '1525388268',
      loanNumberColor: 'default',
      clientName: 'Jackson, Angela',
      loanOfficerAssistant: 'Sarah Johnson',
      manager: 'Michael Chen',
      branch: 'West Coast',
      division: 'Retail',
      lender: 'UWM',
      amount: 157834,
      program: 'R/T',
      state: 'OK',
      lockStatus: 'Uploaded',
      notes: 'waiting on mtg state',
      submittedDate: '11/18/2025',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: 'IN',
      appraisalStatus: 'Appraisal IN 12/18',
      daysInStage: 9,
      statusColor: 'yellow',
      outstandingConditions: generateConditions(4, 'Outstanding'),
      loanOfficerConditions: generateConditions(3, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '2/28/2026',
      loanPurpose: 'Refinance',
      loanType: 'Conventional',
      processor: 'Sarah Johnson',
      lastContactDate: '2/5/2026',
      overdueActionItems: 1,
      loanStatus: 'Active',
    },
  ],
  AWC: [
    {
      id: '4',
      loanNumber: '1525397241',
      loanNumberColor: 'red',
      clientName: 'Jaramillo, Ray',
      loanOfficerAssistant: 'Emily Davis',
      manager: 'Robert Williams',
      branch: 'East Coast',
      division: 'Wholesale',
      lender: 'UWM',
      amount: 206100,
      program: 'C/O',
      state: 'TX',
      lockStatus: '',
      notes: 'Title-Comm, REO, Solar 11/25',
      submittedDate: '11/25/2025',
      payoffReqStatus: 'IN',
      payoffExpDate: '26-Dec',
      hoiReqStatus: 'IN',
      appraisalStatus: 'Appraisal IN $635...',
      daysInStage: 5,
      statusColor: 'red',
      isUrgent: true,
      outstandingConditions: generateConditions(8, 'Outstanding'),
      loanOfficerConditions: generateConditions(12, 'LO'),
      contacts: 'Don/Jake/Francis',
      payoffDue: '1-Jan',
      titleInfo: 'R25TX176846',
      appraisalNotes: 'Appraisal IN $635 PBN',
      loanOfficer: 'Jake Morrison',
      closingDate: '2/18/2026',
      loanPurpose: 'Cash-Out',
      loanType: 'Conventional',
      processor: 'Emily Davis',
      lastContactDate: '2/11/2026',
      overdueActionItems: 3,
      loanStatus: 'Active',
    },
    {
      id: '5',
      loanNumber: '1525400547',
      loanNumberColor: 'default',
      clientName: 'Dugena, Luisa',
      loanOfficerAssistant: 'Jessica Martinez',
      manager: 'Michael Chen',
      branch: 'Midwest',
      division: 'Retail',
      lender: 'UWM',
      amount: 158730,
      program: 'C/O',
      state: 'SC',
      lockStatus: '',
      notes: 'Appraisal, SR VOE(2), SR UB',
      submittedDate: '12/8/2025',
      payoffReqStatus: 'IN',
      payoffExpDate: '8-Jan',
      hoiReqStatus: 'INV LO',
      appraisalStatus: 'waiting on cc auth',
      daysInStage: 3,
      statusColor: 'yellow',
      outstandingConditions: generateConditions(2, 'Outstanding'),
      loanOfficerConditions: generateConditions(4, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '3/5/2026',
      loanPurpose: 'Cash-Out',
      loanType: 'FHA',
      processor: 'Jessica Martinez',
      lastContactDate: '2/9/2026',
      overdueActionItems: 0,
      loanStatus: 'Active',
    },
    {
      id: '6',
      loanNumber: '1525417072',
      loanNumberColor: 'default',
      clientName: 'Overbay, Anthony',
      loanOfficerAssistant: 'Amanda Lee',
      manager: 'Robert Williams',
      branch: 'West Coast',
      division: 'Correspondent',
      lender: 'UWM',
      amount: 233300,
      program: 'C/O',
      state: 'NM',
      lockStatus: '',
      notes: 'Survey 12/11',
      submittedDate: '12/10/2025',
      payoffReqStatus: 'IN',
      payoffExpDate: '16-Jan',
      hoiReqStatus: 'IN',
      appraisalStatus: 'Appraisal IN 12/17',
      daysInStage: 4,
      statusColor: 'yellow',
      outstandingConditions: generateConditions(6, 'Outstanding'),
      loanOfficerConditions: generateConditions(2, 'LO'),
      loanOfficer: 'Mike Thompson',
      closingDate: '3/10/2026',
      loanPurpose: 'Purchase',
      loanType: 'Conventional',
      buyersAgent: 'Sarah Connor',
      processor: 'Amanda Lee',
      lastContactDate: '2/2/2026',
      overdueActionItems: 1,
      loanStatus: 'Nurture',
    },
  ],
  SUBMITTED: [
    {
      id: '7',
      loanNumber: '1525439824',
      loanNumberColor: 'default',
      clientName: 'Carew, Timothy',
      loanOfficerAssistant: 'Sarah Johnson',
      manager: 'Michael Chen',
      branch: 'East Coast',
      division: 'Retail',
      lender: 'UWM',
      amount: 193202,
      program: 'C/O',
      state: 'OH',
      lockStatus: '',
      notes: 'Submitted to Underwriting.',
      submittedDate: '1/7/2026',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: 'UWM',
      appraisalStatus: 'need cc auth',
      daysInStage: 1,
      statusColor: 'default',
      outstandingConditions: generateConditions(1, 'Outstanding'),
      loanOfficerConditions: generateConditions(0, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '3/20/2026',
      loanPurpose: 'Cash-Out',
      loanType: 'Conventional',
      processor: 'Sarah Johnson',
      lastContactDate: '2/13/2026',
      overdueActionItems: 0,
      loanStatus: 'Active',
    },
    {
      id: '8',
      loanNumber: '1526006335',
      loanNumberColor: 'default',
      clientName: 'Villarreal, Matthew',
      loanOfficerAssistant: 'Emily Davis',
      manager: 'Robert Williams',
      branch: 'Midwest',
      division: 'Wholesale',
      lender: 'UWM',
      amount: 197395,
      program: 'C/O',
      state: 'IN',
      lockStatus: '',
      notes: 'Submitted to Underwriting.',
      submittedDate: '1/7/2026',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: 'UWM',
      appraisalStatus: 'waiting on LO',
      daysInStage: 1,
      statusColor: 'default',
      outstandingConditions: generateConditions(2, 'Outstanding'),
      loanOfficerConditions: generateConditions(1, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '4/1/2026',
      loanPurpose: 'Purchase',
      loanType: 'FHA',
      buyersAgent: 'John Doe',
      processor: 'Emily Davis',
      lastContactDate: '2/1/2026',
      overdueActionItems: 0,
      loanStatus: 'Reassigned',
    },
    {
      id: '9',
      loanNumber: '1526006150',
      loanNumberColor: 'default',
      clientName: 'Provencher, Kody',
      loanOfficerAssistant: 'Jessica Martinez',
      manager: 'Michael Chen',
      branch: 'West Coast',
      division: 'Correspondent',
      lender: 'UWM',
      amount: 223128,
      program: 'C/O',
      state: 'VA',
      lockStatus: '',
      notes: 'Submitted to Underwriting.',
      submittedDate: '1/7/2026',
      payoffReqStatus: '',
      payoffExpDate: '',
      hoiReqStatus: 'Force Place',
      appraisalStatus: 'Ordered 01/08',
      daysInStage: 1,
      statusColor: 'red',
      outstandingConditions: generateConditions(5, 'Outstanding'),
      loanOfficerConditions: generateConditions(8, 'LO'),
      loanOfficer: 'Jake Morrison',
      closingDate: '2/25/2026',
      loanPurpose: 'Refinance',
      loanType: 'VA',
      processor: 'Jessica Martinez',
      lastContactDate: '2/10/2026',
      overdueActionItems: 2,
      loanStatus: 'Funded',
    },
  ],
}
